import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, Menu, X } from 'lucide-react';
import useStore from '../store/useStore';
import { cn } from '../lib/utils';

// Text-based logo component matching the exact LUME style
function Logo({ className = "" }) {
  return (
    <span 
      className={cn(
        "font-serif font-semibold tracking-tight text-black",
        className
      )}
      style={{ 
        fontFamily: "'Playfair Display', Georgia, 'Times New Roman', serif",
        letterSpacing: '0.05em'
      }}
    >
      LUME
    </span>
  );
}

export default function Header() {
  const { cart } = useStore();
  const [isOpen, setIsOpen] = React.useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  // Handle both old array format and new Shopify cart object
  const totalItems = cart?.totalQuantity || 0;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-neutral-100 bg-white/90 backdrop-blur-md">
      <div className="container-custom flex h-16 items-center justify-between">
        {/* Mobile Menu Button */}
        <button 
          className="md:hidden p-2 -ml-2" 
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Menu"
        >
          {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>

        {/* Logo */}
        <Link to="/" className="flex items-center" data-testid="header-logo">
          <Logo className="text-2xl md:text-3xl" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex gap-8 items-center text-sm font-medium">
          <div className="relative group">
            <Link to="/butikk" className="hover:text-neutral-600 transition-colors">Butikk</Link>
            <div className="absolute left-0 top-full pt-2 hidden group-hover:block z-50">
              <div className="bg-white border border-neutral-100 rounded-lg shadow-lg py-2 min-w-[160px]">
                <Link to="/butikk" className="block px-4 py-2 text-sm hover:bg-neutral-50 transition-colors">Alle produkter</Link>
                <Link to="/butikk?kategori=sovn" className="block px-4 py-2 text-sm hover:bg-neutral-50 transition-colors">Søvn</Link>
              </div>
            </div>
          </div>
          <Link to="/quiz" className="hover:text-neutral-600 transition-colors">AI-quiz</Link>
          <Link to="/#bundles" className="hover:text-neutral-600 transition-colors">Kombinasjoner</Link>
          <Link to="/#faq" className="hover:text-neutral-600 transition-colors">FAQ</Link>
          <Link to="/helsetips" className="hover:text-neutral-600 transition-colors">Helsetips</Link>
        </nav>

        {/* Cart */}
        <Link to="/handlekurv" className="relative p-2 -mr-2 hover:bg-neutral-50 rounded-full transition-colors" data-testid="header-cart">
          <ShoppingBag className="h-6 w-6" />
          {totalItems > 0 && (
            <span className="absolute top-1 right-0 flex h-4 w-4 items-center justify-center rounded-full bg-black text-[10px] font-bold text-white">
              {totalItems}
            </span>
          )}
        </Link>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="md:hidden border-t border-neutral-100 bg-white px-6 py-4 space-y-4">
          <Link to="/butikk" className="block text-lg font-medium" onClick={() => setIsOpen(false)}>Butikk</Link>
          <Link to="/butikk?kategori=sovn" className="block text-base font-medium text-neutral-500 pl-4" onClick={() => setIsOpen(false)}>— Søvn</Link>
          <Link to="/quiz" className="block text-lg font-medium" onClick={() => setIsOpen(false)}>AI-quiz</Link>
          <Link to="/#bundles" className="block text-lg font-medium" onClick={() => setIsOpen(false)}>Kombinasjoner</Link>
          <Link to="/#faq" className="block text-lg font-medium" onClick={() => setIsOpen(false)}>FAQ</Link>
          <Link to="/helsetips" className="block text-lg font-medium" onClick={() => setIsOpen(false)}>Helsetips</Link>
        </div>
      )}
    </header>
  );
}
